import type { BrandConfig } from '../types';

/** ARG Diamond — feature-rich base brand. */
export const argdiamond: BrandConfig = {
  id: 'argdiamond',
  name: 'ARG Diamond',
  displayName: 'ARG Diamond Club',
  title: 'ARG Diamond',
  colors: {
    // Crorebet-style palette. The header is a flat yellow plate on the
    // reference site, so both gradient stops are the same colour rather than
    // a fake sheen; the button ramp is the yellow -> darker-yellow pressed pair.
    // #ffb700  ->  hsl(43 100% 50%)
    primaryHsl: '43 100% 50%',
    primary: '#ffb700',
    headerGradient: ['#ffb700', '#ffb700'],
    buttonGradient: ['#ffb700', '#d39906'],
  },
  features: {
    fantasy: true,
    aggregator: true,
    liveCasino: true,
    slots: true,
    downloadApk: true,
  },
  urls: {
    app: import.meta.env.VITE_APP_URL ?? 'http://localhost:3002',
  },
  supportEmail: 'info@argdiamond.com',
  /**
   * Placeholder line-up so the "choose your bonus" block renders with real,
   * selectable cards. The wording is deliberately generic: the amounts, the
   * terms and the campaign codes are the operator's to set from the panel, and
   * promising a specific figure here would put an offer in front of players
   * that nobody signed off on. Swap the ids for the real campaign codes.
   */
  signupBonuses: [
    {
      id: 'WELCOME-SPORTS',
      title: 'Sports Welcome Offer',
      subtitle: 'Bonus on your first deposit',
      gradient: ['#7b2ff7', '#2f80ed'],
    },
    {
      id: 'WELCOME-CASINO',
      title: 'Casino Welcome Offer',
      subtitle: 'Free rounds on selected games',
      gradient: ['#f7971e', '#ffd200'],
    },
    {
      id: '',
      title: 'No bonus',
      subtitle: 'Play without a welcome offer',
      gradient: ['#4b4b4b', '#2b2b2b'],
    },
  ],
  assets: {
    // Background-free cut-out of images/logo/logo.jpg — the source has a solid
    // #ffb700 plate baked in, which shows as a box against the #ffb700 header.
    logo: '/images/logo/logo-transparent.png',
    favicon: '/brands/argdiamond/favicon.ico',
    appleTouchIcon: '/brands/argdiamond/apple-touch-icon.png',
  },
};
